import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';

import TimeAgo from 'components/static/time';
import MarkdownReader from 'components/interactive/markdown/MarkdownReader';
import AnnotationEdit from 'components/interactive/annotation/AnnotationEdit';


const Line = styled.div`
  width: 100%;
  height: 0;
  border: 2px solid black;
  border-radius: 2px;
  margin: 30px 0 1px 0;

`;
// `blockquote` fix for inconsistency between markdown editor and reader
const Container = styled.div`
  font-family: ${props=>props.theme.fonts.h5};
  font-size: 13px;
  line-height: 20px;
  blockquote {
    border-left: 5px solid #eee;
    color: #666;
    font-style: italic;
    margin: 16px 0;
    padding: 10px 20px;
  }
  h2 {
    margin: 5px 0;
  }
  p {
    margin: 5px 0;
  }
`

const MetaAndControls = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;


const EditButton = styled.h3`
  font-weight: normal;
  display: inline-block;
  margin: 0;
  padding: 0 10px;
  cursor: pointer;  
  color: #333;
`;

const DeleteButton = styled.h3`
  font-weight: normal;
  display: inline-block;
  margin: 0;
  padding-left: 10px;
  cursor: pointer;  
  color: #333;

`;

const TimeStampLabel = styled.div`
  font-family: ${props=>props.theme.fonts.h5};
  font-weight: normal;
  margin: 0;
  display: inline-block;
  color: #666;
  font-size: 11px;
  font-weight: normal;
`;

const Breakword = styled.div`
  overflow-wrap: break-word;
`;


class AnnotationRead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditor: false
    };
  }

  deleteAnnotation = (event) => {
    const { store } = this.context;
    const { pageId, userId, annotationId } = this.props;
    store.dispatch({
      type: "DELETE_ANNOTATION_REQUESTED",
      payload: {
        pageId: pageId,
        userId: userId,
        annotationId: annotationId,
      }
    });
  }

  toggleEdit = (event) => {
    this.setState({
      showEditor: !this.state.showEditor
    });
  }

  render () {
    const { user, pageId, userId, sectionId, text, annotationId, createdAt, updatedAt } = this.props;
    const showOwnerControls = !this.state.showEditor && user.userId === userId;

    let renderComponent = (<Breakword><MarkdownReader input={ text } /></Breakword>);

    if (this.state.showEditor) {
      renderComponent = (
        <AnnotationEdit
          pageId={pageId} userId={userId}
          sectionId={sectionId}
          annotationId={annotationId}
          text={text}
          onCancel={this.toggleEdit}
        />
      );
    }

    let ts = (updatedAt > createdAt) ? updatedAt : createdAt;
    let label = (updatedAt > createdAt) ? "Edited" : "Posted";


    return (
      <Container>
        <Line/>
        <MetaAndControls>
          <TimeStampLabel>
            { label } <TimeAgo timestamp={ ts }/>
            { showOwnerControls &&
              <EditButton onClick={this.toggleEdit}>Edit</EditButton>
            }
          </TimeStampLabel>
          { showOwnerControls &&
            <DeleteButton onClick={this.deleteAnnotation}>Delete 🗑</DeleteButton>
          }
        </MetaAndControls>
        { renderComponent }
      </Container>
    );
  }
}

AnnotationRead.contextTypes = {
  store: PropTypes.object
};

AnnotationRead.propTypes = {
  pageId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  annotationId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  createdAt: PropTypes.number.isRequired,
  updatedAt: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const user = state.user.data || {};
  return { user };
}

export default connect(mapStateToProps, {})(withRouter(AnnotationRead));



// WEBPACK FOOTER //
// ./src/components/interactive/annotation/AnnotationRead.js